import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(home)/components/ClientCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(home)/components/Stats.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(home)/components/Subtitle.tsx");
